import { DRAWER_WIDTH } from '@/constants/chat';
import {
  mkContactLinkTrackAttrs,
  mkPrivacyLinkTrackAttrs,
  mkResponsibleUseLinkTrackAttrs,
  mkTosLinkTrackAttrs,
} from '@/analytics/props/home';
import { SemanticScholarLogo } from '@/components/icons/SemanticScholarLogo';

import { Box } from '@mui/material';
import styled from 'styled-components';

export const ToS = () => {
  return (
    <Wrapper>
      <Box sx={{ mt: 1, mb: 1 }}>
        <SemanticScholarLogo />
      </Box>
      <List>
        <ListItem>
          <StyledLink
            href="https://forms.gle/EXA19LtehEUc3jo88"
            target="_blank"
            rel="noopener noreferrer"
            {...mkContactLinkTrackAttrs()}
          >
            Contact
          </StyledLink>
        </ListItem>
        <ListItem>
          <StyledLink
            href="https://allenai.org/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            {...mkPrivacyLinkTrackAttrs()}
          >
            Privacy Policy
          </StyledLink>
        </ListItem>
        <ListItem>
          <StyledLink
            href="https://allenai.org/terms"
            target="_blank"
            rel="noopener noreferrer"
            {...mkTosLinkTrackAttrs()}
          >
            Terms of Service
          </StyledLink>
        </ListItem>
        <ListItem>
          <StyledLink
            href="https://allenai.org/responsible-use"
            target="_blank"
            rel="noopener noreferrer"
            {...mkResponsibleUseLinkTrackAttrs()}
          >
            Responsible Use
          </StyledLink>
        </ListItem>
      </List>
    </Wrapper>
  );
};

export const Wrapper = styled.li`
  line-height: ${({ theme }) => theme.spacing(2.625)};
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  font-size: 14px;
  width: ${DRAWER_WIDTH}px; // prevents the ToS from resizing as drawer is opening/closing
`;

export const List = styled.ul`
  color: ${({ theme }) => theme.color['cream-100'].hex};
  list-style-type: none;
  padding: 0;
  text-wrap: wrap;
`;

export const ListItem = styled.li`
  display: inline;
  margin-right: ${({ theme }) => theme.spacing(1)};
  &:nth-of-type(n + 2):before {
    content: '•';
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.palette.text.reversed};
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.palette.secondary.light};
  }
`;
